/*
 * @Author: 🐝
 * @Date: 2023-09-11 14:49:14
 * @LastEditors: Ant🐜
 * @LastEditTime: 2024-08-22 11:00:56
 * @Description: 描述一下
 */
import axios from 'axios'
import { showToast, showFailToast, showDialog } from 'vant'
import router from '../router'
import { getLocal } from '@/common/js/utils'
import { uploadStyleEnum, UPLOAD_GROUP, UPLOAD_PROJECT } from '@/enum/uploadEnum'
import usePage from '@/hooks/usePage'

const { navigateToLogin } = usePage()

const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60000, // request timeout
  withCredentials: true,
  headers: {
    ['X-Requested-With']: 'XMLHttpRequest',
    post: {
      ['Content-Type']: 'application/json'
    }
  }
})

service.interceptors.request.use(
  config => {
    const token = getLocal('token')
    const projectId = getLocal('projectId') || 0
    if (token) {
      config.headers['Auth'] = token
    }
    config.headers['project-id'] = projectId
    config.headers['Ts'] = new Date().valueOf()
    // 上传接口
    if (config.url === '/storage/upload') {
      config.headers = {
        ...config.headers,
        'Content-Type': uploadStyleEnum.FORM_DATA
      }
      config.data = uploadFileData(config)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(res => {
  if (typeof res.data !== 'object') {
    showFailToast('服务端异常！！')
    return Promise.reject(res)
  }
  //toast type:loading success fail html text
  const {
    config: { isTransformRes = true, errorMessageMode = { model: 'toast', option: { type: 'fail' } } }
  } = res
  // 结果不做任何处理
  if (!isTransformRes) return res.data
  const { message, code } = res.data
  if (code !== 0) {
    if (!message) showFailToast('请求失败')
    else {
      const { model, option } = errorMessageMode
      if (model === 'toast') {
        showToast({ message, style: message?.length > 12 ? { width: 130 + 'px' } : {}, ...option })
      } else if (model === 'alert') showDialog({ message, ...(option || {}) })
    }
    // res.data.code === 10000 && navigateToLogin()
    return Promise.reject(res.data)
  }
  return res.data.data || res.data.list
})

// File Upload data
function uploadFileData(config) {
  const formData = new FormData()
  const projectId = getLocal('projectId') || 0
  const params = {
    upload_project: UPLOAD_PROJECT,
    upload_group: UPLOAD_GROUP,
    file: config.data.file,
    project_id: projectId,
    style: config.data.style || uploadStyleEnum.STYLE_PIC_STD
  }
  if (config.data) {
    Object.keys(params).forEach(key => {
      const value = params[key]
      if (Array.isArray(value)) {
        value.forEach(item => {
          formData.append(`${key}[]`, item)
        })
        return
      }
      formData.append(key, params[key])
    })
  }
  return formData
}

export default service
